import React, { useEffect, useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import {
  Container,
  Segment,
  Form,
  Icon,
  Table,
  Pagination,
  Header,
} from 'semantic-ui-react';

import { sendRequest, triggerEvent } from '../../helpers/global';
import { loadOptions } from '../../helpers/market_map';

const DEFAULT_PAGE_LIMIT = 10;

function MarketMapCategoryListView(props) {
  const [optionsGoal, setOptionsGoal] = useState([]);
  const [optionsMarketMap, setOptionsMarketMap] = useState([]);
  const [optionsValueChain, setOptionsValueChain] = useState([]);
  const [searchFields, setSearchFields] = useState({
    search: '',
    goal_id: null,
    market_map_id: null,
    value_chain_id: null,
  });
  const [categories, setCategories] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [paging, setPaging] = useState({
    page: 1,
    totalPages: 0,
  });

  const loadList = (page = 1) => {
    const { search, goal_id, market_map_id, value_chain_id } = searchFields;
    const params = {
      ...(search && { search }),
      ...(goal_id && { goal_id }),
      ...(market_map_id && { market_map_id }),
      ...(value_chain_id && { value_chain_id }),
      page,
      limit: DEFAULT_PAGE_LIMIT,
    };
    setLoadingCategories(true);
    sendRequest({
      node: true,
      noLoad: true,
      method: 'value-chain-types',
      type: 'GET',
      data: params,
      success: (data) => {
        const { count, objects } = data;
        const totalPages = Math.ceil(count / DEFAULT_PAGE_LIMIT);
        setCategories(objects);
        setLoadingCategories(false);
        setPaging({
          ...paging,
          totalPages,
        });
      },
      error: (err) => {
        setLoadingCategories(false);
        triggerEvent('showSnackbar', [{ text: err.message, type: 'error' }]);
      },
    });
  };

  const handleOnDelete = (id) => {
    triggerEvent('showConfirmation', [
      {
        title: `Are you sure want to delete this Value Chain Category?`,
        confirmText: 'Delete',
        cancelText: 'Cancel',
        callback: (confirm) => {
          if (confirm) {
            sendRequest({
              node: true,
              method: `value-chain-types/${id}`,
              type: 'DELETE',
              success: (data) => {
                triggerEvent('showSnackbar', [
                  { text: 'Value Chain Category deleted', type: 'success' },
                ]);
                loadList();
              },
              error: (err) => {
                triggerEvent('showSnackbar', [
                  { text: err.message, type: 'error' },
                ]);
              },
            });
          }
        },
      },
    ]);
  };

  useEffect(() => {
    loadOptions('goals', setOptionsGoal);
    loadOptions('market-maps', setOptionsMarketMap);
    loadOptions('value-chains', setOptionsValueChain);
    loadList();
  }, []);

  return (
    <Container>
      <Header as="h2">Value Chain Categories</Header>
      <Segment>
        <Form>
          <Form.Group widths="equal">
            <Form.Input
              label="Value Chain Category Name"
              placeholder="Search Value Chain Category by name"
              value={searchFields.search}
              onChange={(e, { value }) => {
                setSearchFields({
                  ...searchFields,
                  search: value,
                });
              }}
            />
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Select
              label="SDG"
              placeholder="Select SDG"
              options={optionsGoal}
              clearable
              search
              value={searchFields.goal_id}
              onChange={(e, { value }) => {
                setSearchFields({
                  ...searchFields,
                  goal_id: value,
                  market_map_id: null,
                });
                loadOptions('market-maps', setOptionsMarketMap, {
                  goal_id: value,
                });
              }}
            />
            <Form.Select
              label="Market Map"
              placeholder="Select Market Map"
              options={optionsMarketMap}
              clearable
              search
              value={searchFields.market_map_id}
              onChange={(e, { value }) =>
                setSearchFields({ ...searchFields, market_map_id: value })
              }
            />
            <Form.Select
              label="Chain Position"
              placeholder="Select Chain Position"
              options={optionsValueChain}
              clearable
              search
              value={searchFields.value_chain_id}
              onChange={(e, { value }) =>
                setSearchFields({ ...searchFields, value_chain_id: value })
              }
            />
          </Form.Group>
          <Form.Group>
            <Form.Button positive onClick={() => loadList()}>
              Search
            </Form.Button>
          </Form.Group>
        </Form>
      </Segment>
      <Segment loading={loadingCategories}>
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>SDG</Table.HeaderCell>
              <Table.HeaderCell>Market Map Name</Table.HeaderCell>
              <Table.HeaderCell>Value Chain Category</Table.HeaderCell>
              <Table.HeaderCell>Chain Position</Table.HeaderCell>
              <Table.HeaderCell width={1}></Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {!loadingCategories && categories.length === 0 && (
              <Table.Row>
                <Table.Cell colSpan="5">
                  No Market Map Categories found
                </Table.Cell>
              </Table.Row>
            )}
            {!loadingCategories &&
              categories.length > 0 &&
              categories.map((category) => (
                <Table.Row key={category.id}>
                  <Table.Cell>
                    {category.goal && (
                      <Link to={`/categories/${category.goal.id}`}>
                        {category.goal.name}
                      </Link>
                    )}
                  </Table.Cell>
                  <Table.Cell>
                    {category.market_map && (
                      <Link to={`/market-maps/${category.market_map.id}`}>
                        {category.market_map.name}
                      </Link>
                    )}
                  </Table.Cell>
                  <Table.Cell>{category.name}</Table.Cell>
                  <Table.Cell>
                    {category.value_chain ? category.value_chain.name : ''}
                  </Table.Cell>
                  <Table.Cell width={1}>
                    <Icon
                      link
                      name="pencil"
                      onClick={() =>
                        props.history.push(
                          `/market-map-categories/${category.id}`
                        )
                      }
                    />
                    <Icon
                      link
                      name="trash"
                      onClick={() => handleOnDelete(category.id)}
                    />
                  </Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>

          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan="5">
                <Pagination
                  defaultActivePage={1}
                  siblingRange={2}
                  totalPages={paging.totalPages}
                  onPageChange={(e, { activePage }) => loadList(activePage)}
                />
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </Segment>
      <Link to={`/market-map-categories/create`}>
        <div className="createButton">
          <span className="material-icons">add</span>
        </div>
      </Link>
    </Container>
  );
}

export default withRouter(MarketMapCategoryListView);
